export type PlanKind = "Free" | "Paid";

/** Rotas acessíveis a qualquer plano (e a contas bloqueadas) */
export const FREE_ROUTES: string[] = [
  "/dashboard/app",
  "/dashboard/profile",
  "/dashboard/pricing",
  "/dashboard/planHistory",
  "/dashboard/tutorial",
  "/dashboard/support",
];

const PAID_ONLY_ROUTES: string[] = [
  "/dashboard/query",
  "/dashboard/history",
  "/dashboard/dose",
  "/dashboard/doseOral",
  "/dashboard/actives",
  "/dashboard/cleo",
  "/dashboard/patients",
];

/** Rotas pagas com parâmetro — casadas por prefixo */
const PAID_ONLY_PREFIXES: string[] = [
  "/dashboard/reviewConsult/",
  "/dashboard/reviewOral/",
  "/dashboard/patients/",
];

export function planKind(plan: string | null | undefined): PlanKind {
  return plan != null ? "Paid" : "Free";
}

export function canAccessRoute(plan: PlanKind, path: string): boolean {
  if (FREE_ROUTES.includes(path)) return true;
  if (plan !== "Paid") return false;
  return (
    PAID_ONLY_ROUTES.includes(path) ||
    PAID_ONLY_PREFIXES.some((prefix) => path.startsWith(prefix))
  );
}
